// extracted by mini-css-extract-plugin
export var chevron = "_jc-4";
export var chevronExpanded = "_jc-5";
export var row = "_jc-0";
export var rowBody = "_jc-6";
export var rowDescription = "_jc-7";
export var rowHeader = "_jc-1";
export var rowTitle = "_jc-2";
export var rowTitleComplete = "_jc-3";